module.exports = __webpack_public_path__ + "static/media/CircularPro-BookItalic.61ab5407.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-BookItalic.otf
// module id = 114
// module chunks = 0